'use strict';

var selector = ".ix-delete-contact";

$(selector).click(function (e) {

    if (!$(this).hasClass('rwi-btn-danger')) {
        e.preventDefault();
        $(this).addClass('rwi-btn-danger').html('<i class="ri-trash"></i> Confirm Delete Contact');
    } else {
        var id = $(this).data('id');
        var form = $('#delete-' + id).submit();
    }
});


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/stores/deleteContact.js
// module id = 528
// module chunks = 0